import {
  type DemandeStore,
  type PrintAction,
  buildPrintDemandeWithTemplate,
  useDemandePrint,
} from '@/features/interface/demande/shared'
import { redirectExterne } from '@/features/shared/tools'

const actionPrintGlossaire: PrintAction = {
  label: 'Générer le glossaire',
  iconName: 'document-text',
  buttonType: 'icon',
  jobs: () => redirectExterne('https://ressourcesstatiques.akto.fr/guide/v2/GlossaireProformaGroupee.xlsx'),
} as const

export function useDemandeProformaPrint(store: DemandeStore<'MODEL_PROFORMA'>) {
  const actionPrintCerfa: PrintAction = {
    mustSave: true,
    label: 'Générer la Proforma',
    jobs: [
      buildPrintDemandeWithTemplate<'MODEL_PROFORMA'>({
        store,
        typeDocumentTemplate: 'ProForma',
        filenameKeys: ['financeur', 'reference'],
      }),
      buildPrintDemandeWithTemplate<'MODEL_PROFORMA'>({
        store,
        typeDocumentTemplate: 'ProFormaAnnexe',
        filenameKeys: ['financeur', 'reference'],
      }),
    ],
  }

  return useDemandePrint<'MODEL_PROFORMA'>({
    store,
    getActions: () => [actionPrintCerfa, actionPrintGlossaire],
  })
}
